import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import './skeletonPosts.css'

const SkeletonPosts = () => {
  return (
    <>
        <div className="post">
            <div className="postWrapper">
                <div className="postTop">
                    <div className="postTopLeft">
                        <Skeleton circle className="postProfileImg"/>
                        <Skeleton className="postUsername" width={'7rem'} style={{marginLeft: '.75rem'}}/>
                        <Skeleton className="postUsername" width={'7rem'}/>
                    </div>
                </div>
                <div className="postCenter">
                    <Skeleton className="postText"/>
                    <Skeleton className="postText"/>
                    <Skeleton className="postText"/>
                </div>
                <div className="postBottom">
                    <div className="postBottomLeft">
                        <Skeleton circle className="likeButton" width={'1rem'}/>
                        <Skeleton width={'5rem'}/>
                    </div>
                </div>
            </div>
        </div>
        <div className="post">
            <div className="postWrapper">
                <div className="postTop">
                    <div className="postTopLeft">
                        <Skeleton circle className="postProfileImg"/>
                        <Skeleton className="postUsername" width={'7rem'} style={{marginLeft: '.75rem'}}/>
                        <Skeleton className="postUsername" width={'7rem'}/>
                    </div>
                </div>
                <div className="postCenter">
                    <Skeleton className="postText"/>
                    <Skeleton className="postText"/>
                    <Skeleton className="postText"/>
                </div>
                <div className="postBottom">
                    <div className="postBottomLeft">
                        <Skeleton circle className="likeButton" width={'1rem'}/>
                        <Skeleton width={'5rem'}/>
                    </div>
                </div>
            </div>
        </div>
        <div className="post">
            <div className="postWrapper">
                <div className="postTop">
                    <div className="postTopLeft">
                        <Skeleton circle className="postProfileImg"/>
                        <Skeleton className="postUsername" width={'7rem'} style={{marginLeft: '.75rem'}}/>
                        <Skeleton className="postUsername" width={'7rem'}/>
                    </div>
                </div>
                <div className="postCenter">
                    <Skeleton className="postText"/>
                    <Skeleton className="postText"/>
                    <Skeleton className="postText"/>
                </div>
                <div className="postBottom">
                    <div className="postBottomLeft">
                        <Skeleton circle className="likeButton" width={'1rem'}/>
                        <Skeleton width={'5rem'}/>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default SkeletonPosts